import { render } from "./ReferralEarningsView.vue?vue&type=template&id=0d164709&scoped=true"
import script from "./ReferralEarningsView.vue?vue&type=script&lang=js"
export * from "./ReferralEarningsView.vue?vue&type=script&lang=js"

import "./ReferralEarningsView.vue?vue&type=style&index=0&id=0d164709&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d164709"]])

export default __exports__